import { SOVEREIGN } from '../../epc/utils/epcProjectVisual';

const STEP_TITLES = ['Basics', 'Placement', 'Permissions', 'Review'];

interface Props {
  title: string;
  subtitle?: string;
  current: number;
  maxStepReached: number;
  stepHasError: boolean[];
  onClose: () => void;
  onJump: (step: number) => void;
}

export function FeatureWizardHeader({ title, subtitle, current, maxStepReached, stepHasError, onClose, onJump }: Props) {
  const pct = ((current + 1) / STEP_TITLES.length) * 100;
  return (
    <div
      className="sticky top-0 z-10 -mx-6 -mt-6 mb-5 px-6 pt-5 pb-4"
      style={{
        background: SOVEREIGN.cardBg,
        borderBottom: `1px solid ${SOVEREIGN.innerRule}`,
      }}
    >
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-3">
          <div
            className="w-10 h-10 rounded-xl flex items-center justify-center text-xl"
            style={{
              background: 'rgba(31,90,71,0.08)',
              border: `1px solid ${SOVEREIGN.cardBorder}`,
            }}
          >
            🧩
          </div>
          <div>
            <h2
              className="text-lg font-extrabold"
              style={{ color: SOVEREIGN.title }}
            >
              {title}
            </h2>
            {subtitle && (
              <p
                className="text-xs"
                style={{ color: SOVEREIGN.kpiCaption }}
              >
                {subtitle}
              </p>
            )}
          </div>
        </div>
        <button
          onClick={onClose}
          aria-label="Close"
          className="p-2 rounded-lg transition-colors"
          style={{ color: SOVEREIGN.kpiCaption }}
        >
          ✕
        </button>
      </div>

      <div className="mt-4 flex items-center gap-2">
        {STEP_TITLES.map((t, i) => {
          const reachable = i <= maxStepReached;
          const active = i === current;
          const error = stepHasError[i];
          return (
            <button
              key={t}
              type="button"
              disabled={!reachable}
              onClick={() => reachable && onJump(i)}
              className="flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold transition-colors"
              style={
                error
                  ? { background: '#fef2f2', color: '#b91c1c', border: '1px solid #fca5a5' }
                  : active
                    ? { background: SOVEREIGN.bottle, color: '#fff' }
                    : reachable
                      ? { background: 'rgba(31,90,71,0.08)', color: SOVEREIGN.bottle }
                      : { background: SOVEREIGN.paper, color: SOVEREIGN.barTrack, cursor: 'not-allowed' }
              }
            >
              <span
                className="w-4 h-4 rounded-full flex items-center justify-center text-[10px]"
                style={{
                  background: active ? 'rgba(255,255,255,0.25)' : 'rgba(0,0,0,0.08)',
                  color: active ? '#fff' : 'inherit',
                }}
              >
                {i + 1}
              </span>
              {t}
            </button>
          );
        })}
      </div>

      <div
        className="mt-3 h-1.5 w-full rounded-full overflow-hidden"
        style={{ background: SOVEREIGN.barTrack }}
      >
        <div
          className="h-full transition-all duration-300"
          style={{ width: `${pct}%`, background: SOVEREIGN.barFill }}
        />
      </div>
    </div>
  );
}
